import styled from 'styled-components';

import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import { LanguageItem } from '../LanguageSwitch/LanguageSwitch.styles';
import LoginButton from '../LoginButton/LoginButton';

export const BlackOverlay = styled.div`
  width: 100%;
  height: 100%;
  background: var(--color-black);
  opacity: ${({ navIsOpen }) => (navIsOpen ? '0.5' : '0')};
  visibility: ${({ navIsOpen }) => (navIsOpen ? 'visible' : 'hidden')};
  position: fixed;
  top: 0;
  left: 0;
  transition: all var(--transition-default);

  ${({ navIsOpen }) =>
    navIsOpen &&
    `
    opacity: 0.5;
    visibility: visible;
  `}

  @media (${({ theme }) => theme.respondTo.mobile}) {
    display: none;
  }
`;

export const NavBottom = styled.div`
  margin-top: auto;

  .line-break {
    margin: 3rem 0;
    height: 1px;
    /* width: 100%; */
    background-color: var(--border-transparent);
  }

  .app-store-icon {
    cursor: pointer;
    display: inline-block;
    height: 4rem;
    /* margin-right: 2rem; */
  }
  .android-link {
    float: right;
  }
  .google-store-icon {
    cursor: pointer;
    display: inline-block;
    height: 4rem;
  }

  div:last-child {
    @media (${({ theme }) => theme.respondTo.tablet}) {
      display: none;
    }
  }

  .icons-grid-container {
    display: grid;
    grid-template-columns: 17.5rem 1fr;
    @media (${({ theme }) => theme.respondTo.tablet}) {
      grid-template-columns: 19rem 1fr;
    }
  }
`;

export const NavColumn = styled.nav`
  &:not(:first-child) {
    margin-top: 6rem;
  }

  a {
    &:hover {
      color: var(--color-primary);
    }
  }
`;

export const NavLinks = styled.ul`
  display: grid;
  grid-template-columns: 17.5rem 1fr;
  line-height: var(--line-height-default);

  @media (${({ theme }) => theme.respondTo.mobile}) {
    font-size: var(--font-size-sm);
  }

  @media (${({ theme }) => theme.respondTo.tablet}) {
    grid-template-columns: 19rem 1fr;
  }
`;

export const NavTitle = styled.span`
  font-family: var(--font-tertiary);
  font-size: 2.5rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-primary);
  display: block;
  margin-bottom: 1.5rem;
`;

export const StyledLanguageSwitch = styled(LanguageSwitch)`
  ${LanguageItem} {
    font-size: var(--font-size-xs);
    color: ${({ isActive }) => (isActive ? 'var(--color-primary)' : 'var(--color-gray)')};
    margin-right: 1.5rem;

    &:hover {
      color: var(--color-primary);
    }

    @media (${({ theme }) => theme.respondTo.tablet}) {
      font-size: var(--font-size-sm);
    }
  }
`;

export const StyledLoginButton = styled(LoginButton)`
  width: 100%;
  margin-top: 2.5rem;
  @media (${({ theme }) => theme.respondTo.tablet}) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  color: var(--color-text-dark);
  width: 100%;
  height: 100%;
  background: var(--color-white);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 2;
  transform: ${({ navIsOpen }) => (navIsOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform var(--transition-default) ease-out;
  padding: 13.5rem 3rem 3rem;

  @media (${({ theme }) => theme.respondTo.tablet}) {
    width: 48rem;
    padding: 22rem 7rem 7rem;
  }
`;
